<template>
  <div class="flower__wrap">
    <div class="flower-title__wrap">
      <h4>근조화환 추모</h4>
      <div
        v-if="isWreathList"
        class="flower-icon__wrap"
        @click="$emit('handleViewWreath')"
      >
        <h4>전체보기</h4>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
    </div>

    <!-- List 형태로 근조화환을 표현합니다. -->
    <div
      v-if="isWreathList"
      class="msg-card-flower"
      @click="$emit('handleViewWreath')"
    >
      <div
        v-for="(wreath, i) in displayedWreaths"
        :key="i"
        class="message-item"
      >
        <v-sheet>
          <div class="d-flex align-center mt-4 ml-4 mb-4 mr-8">
            <img
              src="../../assets/images/obituary/flower-photo.png"
              alt=""
              class="msg-card-flower-img"
            />

            <div>
              <h6 class="line-clamp" style="font-size: 14px; font-weight: 700">
                {{ wreath.NAME }}
              </h6>
              <p class="line-clamp" style="color: #555555">
                {{ wreath.COMMENT_NO }}
              </p>
            </div>
          </div>
        </v-sheet>
      </div>
      <button class="msg-button" @click="$emit('goShop')">
        근조화환으로 추모의 마음 전하기
      </button>
    </div>

    <button v-else class="msg-card-flower__bin" @click="$emit('goShop')">
      <div class="d-flex align-center mt-4 ml-4 mb-4 mr-8">
        <img
          src="../../assets/images/obituary/flower-photo.png"
          alt=""
          class="msg-card-flower-img"
        />
        <div>
          <h6 class="line-clamp">근조화환으로 마음을 보내주세요</h6>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "ObituaryWreath",
  props: ["obituaryWreaths"],
  computed: {
    isWreathList() {
      return this.obituaryWreaths && this.obituaryWreaths.length > 0;
    },
    displayedWreaths() {
      return [...this.obituaryWreaths].reverse().slice(0, 3);
    },
  },
};
</script>

<style></style>
